import React from 'react'
import { Form, Input, Select } from 'antd';
import TextEditorReadOnly from '../../../text/TextEditorReadOnly';
import ItemRecepyWikiTable from './ItemRecepyWikiTable';
const { Option } = Select;

export default function ItemWikiForm({
    form,
    onFinish,
    record,
    tools,
    allItems
}) {

    const layout = useFormLayout();

    const toolOptions = tools.map(tool => {
        return (<Option 
          value={tool.id} 
          key={tool.id}
        >
          {tool.name}
        </Option>)
      })


    return (
        <>
            <Form 
                form={form}
                {...layout}
                name="basic"
                layout="horizontal"
                onFinish={onFinish}
                >

                    <Form.Item
                        label="Id"
                        name="id"
                    >
                        <Input name="id" disabled/>
                    </Form.Item>

                    <Form.Item
                        label="Name"
                        name="name"
                    >
                        <Input name="name" disabled/>
                    </Form.Item>

                {record.tool?.id &&
                    <Form.Item
                        label="Tool"
                        name="toolId"
                    >
                        <Select 
                            allowClear
                            name="toolId" 
                            disabled
                        >
                            {toolOptions}
                        </Select>
                    </Form.Item>
                }
                <Form.Item
                      label={"Description"}
                      name={"description"}
                >
                        <TextEditorReadOnly content={record.description}/>
                </Form.Item>

                {record.tool?.id &&
                    <>
                        <p>Recepies</p>
                        <ItemRecepyWikiTable 
                            item={record}
                            allItems={allItems}
                        />
                    </>
                }
            </Form>
        </>
    )

    function useFormLayout()
    {
        return {
            hideRequiredMark: true,
            colon: false,
            layout:"inline"
        }
    }
}

